
import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'

import { projectContext, loadingContext, urlValue, unfolder, closeModalVw, openModalVw } from '../../lib'
// import AsideBar from './AsideBar'

import './compliance-hits.scss'
import { customModal } from '../../styles/customModal'
import SideBar from '../../components/SideBar'
import TitleBar from '../../components/TitleBar'
import { useNavigate } from 'react-router-dom'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import Report from '../Report'
import ReportItem from './ReportItem'
// import MenuHeader from './MenuHeader'
// import trash from "../img/icons/trash.png"
// import expandleft from "../img/icons/Expand_left.svg"
// import searchicon from "../img/icons/search.svg"
// import editicon from "../img/icons/edit.png"
// import watchReport from "../img/icons/see-report-icon.jpg"

export default function ComplianceHits(props) {
    const { data } = props
    const [loading, setLoading] = useState(false)
    const [assement, setAssement] = useState(data)

    useEffect(() => {
        setAssement(data)
    }, [data])


    const getClass =   (acurracy) => {
        if (acurracy < 50) {
            return 'red'
        }
        else if (acurracy > 50 && acurracy <= 80) {
            return 'orange'
        }
        else if (acurracy > 80) {
            return 'green'
        }
    }

    const getComplianceHits = () => {
        return assement.assesment.compliance.hits.map((item) => ({
            ...item,
            'class': getClass(item.accuracy)
        }));

    }

    const getResolutionHits = () => {
        return assement.assesment.resolution.hits.map((item) => ({
            ...item,
            'class': getClass(item.accuracy)
        }));
    }

    const getDisclaimerHits = () => {
        return assement.assesment.disclaimer.hits.map((item) => ({
            ...item,
            'class': getClass(item.accuracy * 100)
        }));
    }
    return (

        <>
            <div class="compliance">
                {assement.type == 'NLP' && <h3 className='font-bold text-[#36A9E1]'  >Compliance</h3>}
                {getComplianceHits().map((item, index) => (
                    <div key={index} class="conversation conversation-suggested"  >
                        <div class="text-agent">
                            <div>
                                <img src="/icons/iconTpAgent.png" alt="" />
                            </div>
                            <div class="text">
                                <span className={item.class}>
                                    {item.used_phrase}
                                </span>
                                <img src={`/icons/triangle${item.class}.png`} alt="" />
                                <b>We recomended you use</b>
                            </div>
                        </div>

                        <div class="text-client">
                            {item.suggested_phrase}
                        </div>
                    </div>
                ))}

                {assement.type == 'NLP' && <h3 className='font-bold text-[#36A9E1]'  > Resolution</h3>}

                {getResolutionHits().map((item, index) => (

                    <div key={index} class="conversation conversation-suggested"  >
                        <div class="text-agent">
                            <div>
                                <img src="/icons/iconTpAgent.png" alt="" />
                            </div>
                            <div class="text">
                                <span className={item.class}>
                                    {item.used_phrase}
                                </span>
                                {assement.type == 'NLP' && <img src={`/icons/triangle${item.class}.png`} alt=""  />}
                                <b>We recomended you use</b>
                            </div>
                        </div>
                        <div class="text-client">
                            {item.suggested_phrase}
                        </div>
                    </div>))
                }

                {assement.type == 'NLP' && <h3  className='font-bold text-[#36A9E1]'  > Disclaimer</h3>}

                {getDisclaimerHits().map((item, index) => (
                    <div class="conversation conversation-suggested"   >
                        <div class="text-agent">
                            <div>
                                <img src="/icons/iconTpAgent.png" alt="" />
                            </div>
                            <div class="text">
                                <span className={item.class}>
                                    {item.used_phrase}
                                </span>
                                <img src={`/icons/triangle${item.class}.png`} alt="" />
                                <b>We recomended you use</b>
                            </div>
                        </div>
                        <div class="text-client">
                            {item.suggested_phrase}
                        </div>
                    </div>))}
            </div>


        </>


    )
}
